/* eslint-disable dot-notation */
import { Project } from 'projen';
import { SourceCode, SourceCodeOptions } from './source-code.js';

describe('SourceCode', () => {
  let project: Project;
  let sourceCode: SourceCode;

  beforeEach(() => {
    project = new Project({ name: 'test' });
    const options: SourceCodeOptions = {
      codeBlock: 'logger.info("Hello, world!");',
    };
    sourceCode = new SourceCode(project, 'src/index.ts', options);
  });

  it('synthesizes content correctly', () => {
    const expectedContent = [
      '// ~~ Generated by projen. To modify, edit .projenrc.js and run "npx projen".',
      'logger.info("Hello, world!");',
      '',
    ].join('\n');

    expect(sourceCode['synthesizeContent']()).toEqual(expectedContent);
  });
});
